import React, { Fragment, useEffect, useContext, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { observer, useObserver } from "mobx-react-lite";
import Grid from "@material-ui/core/Grid";

/* container */
import CMSContainer from "../../app-module-cms-container/default";
/* container */

/* packages */
import { GlobalContext } from "../../lib-atomic-context";
import {
  ModuleContainerLg,
  ModuleFormWrapper,
  ModuleFormItemWrapper,
  ModulePaddedWrapperLg,
  ModulePaperWrapper,
  ModuleTitle,
  ModuleText,
  ModuleTextBold,
} from "../../lib-atomic-design-section";
import { Buttons } from "../../lib-atomic";
/* packages */

/* module */
import CMSActivateHeader from "../../app-module-cms-section-activate-header/default";
/* module */

const index = (props) => {
  console.log(props);
  const { forgotpasswordupdate } = useContext(GlobalContext);
  console.log(forgotpasswordupdate);
  const isSuccessfullyUpdated = props.location.state
    ? props.location.state.isSuccessfullyUpdated
    : false;
  const isAlreadyUsed = props.location.state
    ? props.location.state.isAlreadyUsed
    : false;
  const isAlreadyExpired = props.location.state
    ? props.location.state.isAlreadyExpired
    : false;
  const handleBack = () => {
    props.history.push("/corporate/forgot_password/request");
  };
  const handleForward = () => {
    props.history.push("/corporate/login");
  };
  /* data props */
  const backButton = { size: "medium", onClick: handleBack };
  const forwardButton = { size: "medium", onClick: handleForward };
  // if (!warning) setWarning("Card Number, Reference Number or Invoice Number not valid.")
  return (
    <Fragment>
      <ModuleFormItemWrapper>
        <ModulePaperWrapper>
          {isSuccessfullyUpdated && (
            <ModuleTitle>
              You have created a new password for your account
            </ModuleTitle>
          )}
          {!isSuccessfullyUpdated && (
            <ModuleTitle>Password Update Unsucccessful</ModuleTitle>
          )}

          {/* content wording : false */}
          {!isSuccessfullyUpdated && isAlreadyUsed && (
            <ModuleText>
              Password reset link has already been used. Request again to
              update.
            </ModuleText>
          )}

          {/* content wording : false */}
          {!isSuccessfullyUpdated && isAlreadyExpired && (
            <ModuleText>
              Reset form has already been expired. Request again to update.
            </ModuleText>
          )}

          {/* content wording : false */}
          {!isSuccessfullyUpdated && !isAlreadyUsed && !isAlreadyExpired && (
            <ModuleText>Please contact our suppport</ModuleText>
          )}

          {/* content wording */}
          {isSuccessfullyUpdated && (
            <ModuleText>You can now login using your new password.</ModuleText>
          )}

          <br />
          <ModuleFormWrapper>
            <ModuleFormItemWrapper>
              {!isSuccessfullyUpdated && (
                <Buttons.Normal {...backButton}>BACK</Buttons.Normal>
              )}
              {isSuccessfullyUpdated && (
                <Buttons.Normal {...forwardButton}>
                  Continue to login
                </Buttons.Normal>
              )}
            </ModuleFormItemWrapper>
          </ModuleFormWrapper>
        </ModulePaperWrapper>
      </ModuleFormItemWrapper>
    </Fragment>
  );
};

export default index;
